import { linkToChild } from "../../links";

export function linkToChildAssignmentsPage(userId: string = ":userId") {
  return `${linkToChild(userId)}/assignments`;
}
